import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

const schema = z.object({
  q: z.string().optional(),
  apps: z.string().array().optional(),
});

export default {
  schema,
  resolver: zodResolver(schema),
};
